module.exports = __webpack_public_path__ + "img/New-message-pana-grey.27a6e315.png";